import { createApp } from 'vue';
import App from './App.vue';
import router from './router.js';
import store from './store/index.js'
// import { BAlert } from 'bootstrap-vue'
import 'bootstrap-icons/font/bootstrap-icons.css'
// Marketing-site tokens (landing page palette) first, then the dashboard
// design system — design.css owns the product's beige/blue palette and must
// load last so its base rules win.
import './assets/css/design-token.css'
import './assets/css/design.css'
import { revealDirective, countDirective, tiltDirective } from '../src/store/motion.js'



// createApp(App).mount('#app')
const app = createApp(App)

import HeroSection from './components/layouts/HeroSection.vue';
import HeaderSection from './components/layouts/Header.vue';
import BaseButton from './components/layouts/Button.vue';


import FeatureSection from './components/layouts/Features.vue';
import FooterSection from './components/layouts/Footer.vue';
import MainNavigation from './components/layouts/MainNavigation'
// FirstVisitGuide and OnboardingTour are registered locally in App.vue —
// they're only ever used there.

import VueSidebarMenuAkahon from "vue-sidebar-menu-akahon";
import moment from 'moment-timezone'

moment.tz.setDefault('Africa/Nairobi')

// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.min.css'


app.directive('reveal', revealDirective)
app.directive('count', countDirective)
app.directive('tilt', tiltDirective)


app.use(store);
app.use(router);
// app.use(BootstrapVue);
// app.use(IconsPlugin);
app.component('hero-section',HeroSection);
app.component('base-button',BaseButton);

app.component('header-section',HeaderSection);
app.component('footer-section', FooterSection);
app.component('vue-sidebar', VueSidebarMenuAkahon)
app.component('feature-section',FeatureSection)
app.component('main-navigation', MainNavigation)
// app.component('b-alert', BAlert)
// app.use(VueMaterial)

app.mount('#app');

//new one
